// src/api/bookingApi.js
import axios from "axios";
import { API_URL } from "../apiConfig";

export const createBooking = async (bookingData) => {
  try {
    const response = await axios.post(`${API_URL}/api/booking`, bookingData);
    return response.data;
  } catch (error) {
    console.error("Error creating booking:", error);
    throw error;
  }
};
